<template>
  <PropertyCheckList v-if="items.length" :items="items" />
  <Text v-else variant="body-medium">No amenities</Text>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Text } from '@tallo/design-system';

import { Amenity, amenityIconsMap, amenityNamesMap } from '../../model/amenities';
import { PropertyDto } from '../../model/property';
import PropertyCheckList, { CheckListItem } from './property-check-list.vue';

const props = defineProps<{
  property: PropertyDto | null | undefined;
}>();

// false is an explicit "not included" from the owner's ✓/✗ form; null means never answered and stays hidden.
// Included amenities come first, then the crossed-out ones
const items = computed<CheckListItem[]>(() =>
  Object.entries(props.property?.amenities || {})
    .filter(([key, value]) => key in amenityNamesMap && value !== null && value !== undefined)
    .map(([key, value]) => ({
      label: amenityNamesMap[key as Amenity],
      value: value as boolean,
      icon: amenityIconsMap[key as Amenity],
    }))
    .sort((a, b) => Number(!a.value) - Number(!b.value) || a.label.localeCompare(b.label)),
);
</script>
